"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var subscribeOn_1 = require("../../operator/subscribeOn");
rxjs_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs-compat/add/operator/subscribeOn.js
// module id = 1226
// module chunks = 0